import React, { useEffect } from "react";

export default function App() {
  useEffect(() => {
    // Redirect to angelai.com when component mounts
    window.location.href = 'https://www.angelai.com/';
  }, []);

  // Return null to prevent any rendering during redirect
  return null;
}